/**
 * Ferskhet for nedlastede offline-kartområder (UX-prinsipp #6 tapsaversjon, grep B —
 * se docs/plan-ux-principles-retention.md). Ærlig tapsramme: et offline-kart som er
 * gammelt kan ha utdaterte veier/plasser, så vi varsler når det er verdt å laste ned
 * på nytt. Dette er et genuint NYTTIG varsel som også motiverer — innenfor gissel-
 * grensen (feedback_honest_persuasion_rules): vi holder ingenting som gissel, vi
 * påpeker bare at dataene eldes.
 *
 * Ren og tidsuavhengig (now injiseres) så den er fullt testbar.
 */

export type OfflineFreshnessLevel = 'fresh' | 'stale' | 'very_stale';

/** Fra denne alderen anses kartet som modent nok til å nevne at det kan være utdatert. */
export const OFFLINE_STALE_DAYS = 90;

/** Fra denne alderen er kartet så gammelt at varselet bør være tydeligere. */
export const OFFLINE_VERY_STALE_DAYS = 180;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/** Hele dager mellom nedlasting og nå. Negativt (fremtidig ts) klemmes til 0. */
export function getOfflineAreaAgeDays(createdAt: number, now: number): number {
  return Math.max(0, Math.floor((now - createdAt) / MS_PER_DAY));
}

export interface OfflineAreaFreshness {
  ageDays: number;
  level: OfflineFreshnessLevel;
  /** Kortform: bør vi i det hele tatt vise et ferskhet-hint? */
  isStale: boolean;
}

export function getOfflineAreaFreshness(createdAt: number, now: number): OfflineAreaFreshness {
  const ageDays = getOfflineAreaAgeDays(createdAt, now);
  const level: OfflineFreshnessLevel =
    ageDays >= OFFLINE_VERY_STALE_DAYS ? 'very_stale' :
    ageDays >= OFFLINE_STALE_DAYS ? 'stale' :
    'fresh';
  return { ageDays, level, isStale: level !== 'fresh' };
}
